import type { CognitoAccessTokenPayload } from 'aws-jwt-verify/jwt-model';
import { cognitoVerifier, cognitoVerifierSic } from './cognito-verifier';

/**
 * Verifica si un token es de Cognito
 * @param token
 * @returns true si es de Cognito, false en caso contrario
 */
export async function verifyCognitoJwt(
  token: string,
  cognitoSourceToken: string,
): Promise<{ payload: CognitoAccessTokenPayload | null; isValid: boolean }> {
  try {
    const verifier =
      cognitoSourceToken === 'cognito-sic'
        ? cognitoVerifierSic
        : cognitoVerifier;

    const payload: CognitoAccessTokenPayload = await verifier.verify(token);

    return { payload, isValid: true };
  } catch (ex: any) {
    console.error('❌ Error verifying JWT:', {
      cognitoSourceToken,
      error: 'message' in ex ? ex.message : ex,
      usingVerifier:
        cognitoSourceToken === 'cognito-sic'
          ? 'SIC_VERIFIER'
          : 'INSPECTOR_VERIFIER',
    });

    return { payload: null, isValid: false };
  }
}
